import { render, staticRenderFns } from "./addressDia.vue?vue&type=template&id=494baa50&scoped=true"
import script from "./addressDia.vue?vue&type=script&lang=js"
export * from "./addressDia.vue?vue&type=script&lang=js"
import style0 from "./addressDia.vue?vue&type=style&index=0&id=494baa50&prod&lang=scss"
import style1 from "./addressDia.vue?vue&type=style&index=1&id=494baa50&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "494baa50",
  null
  
)

export default component.exports